import { useMemo } from 'react';
import type {
  VipComparisonCol,
  VipComparisonRow,
  VipComparisonSection,
} from '@/api/cms/vip';
import { useGetCommonStore } from '@/store';
import type {
  IComparisonUICell,
  IComparisonUICol,
  IComparisonUIData,
  IComparisonUIRow,
  IComparisonUISection,
} from '../types';

type CellsTuple = [IComparisonUICell, IComparisonUICell, IComparisonUICell];

const toUICol = (col: VipComparisonCol): IComparisonUICol => ({
  id: col.id,
  title: col.title,
  subTitle: col.subTitle,
  levelLabel: col.levelLabel,
  badgeUrl: col.badge?.url ?? '',
});

const toUICells = (row: VipComparisonRow): CellsTuple => [
  { text: row.col_1Text, imgUrl: row.col_1Img?.url ?? null },
  { text: row.col_2Text, imgUrl: row.col_2Img?.url ?? null },
  { text: row.col_3Text, imgUrl: row.col_3Img?.url ?? null },
];

const toUIRow = (row: VipComparisonRow): IComparisonUIRow => ({
  id: row.id,
  label: row.label,
  cells: toUICells(row),
});

const toUISection = (section: VipComparisonSection): IComparisonUISection => ({
  id: section.id,
  title: section.title,
  rows: section.rows.map(toUIRow),
});

export const useComparisonData = (): IComparisonUIData => {
  const useCommonStore = useGetCommonStore();
  const vip = useCommonStore.use.vip();

  return useMemo(
    () => ({
      title: vip?.comparisonTableTitle ?? '',
      colsTitle: vip?.comparisonColsTitle ?? '',
      cols: (vip?.comparisonCols ?? []).map(toUICol),
      sections: (vip?.comparisonSections ?? []).map(toUISection),
    }),
    [vip]
  );
};
